import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Header from "./Header";
import Hero from "./Hero";
import Numbers from "./Numbers";
import Payments from "./Payments";
import BusinessType from "./BusinessType";
import Partners from "./Partners";
import Security from "./Security";
import Testimonial from "./Testimonial";
import Faq from "./Faq";
import Footer from "./Footer";
import About from "./about-us/About";
import BulkPayment from "./services/bulk-payment/BulkPayment";
import SupplierSettlment from "./services/SupplierSettlment";
import CashManagement from "./services/CashManagement";
import Airtime from "./services/Airtime";
import Utility from "./utility/Utility";
import Personal from "./personal/Personal";
import Contact from "./contact/Contact";

function Landing() {
  const location = useLocation();
  const [active, setActive] = useState("home");
  const [activeTab, setActiveTab] = useState("business");

  // Check if navigated with state to show contact section
  useEffect(() => {
    if (location.state?.section) {
      setActive(location.state.section);
    }
  }, [location.state]);

  console.log("active", active);
  useEffect(() => {
    const container = document.getElementById("landing-container");
    if (container) {
      container.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [active, activeTab]);
  return (
    <>
      <div
        className="overflow-y-auto min-h-screen h-screen w-full pb-8 lg:pb-12 font-lexendS bg-[#fff]"
        id="landing-container"
      >
        <Header active={active} setActive={setActive} activeTab={activeTab} setActiveTab={setActiveTab} />
        {active === "contact" ? (
          <Contact />
        ) : active === "about" ? (
          <About />
        ) : active === "bulk-payment" ? (
          <BulkPayment setActive={setActive} />
        ) : active === "bill-settlement" ? (
          <SupplierSettlment setActive={setActive} />
        ): active === "petty-cash" ? (
          <CashManagement setActive={setActive} />
        ) :active === "airtime-data" ? (
          <Airtime setActive={setActive} />
        ):active === "utility" ? (
          <Utility setActive={setActive} />
        ) : activeTab === "personal" ? (
          <Personal />
        ) : (
          <>
            {" "}
            <div className="bg-img-2 h-auto pt-[5rem]" id="home">
              <div className="lg:px-[5.69rem] px-3  lg:min-h-[47.125rem] min-h-auto ">
                <Hero />
              </div>
            </div>
            <div className="bg-busines-type h-auto py-[3.06rem]" id="numbers">
              <div className="lg:px-[5.69rem] px-3 ">
                <Numbers />
              </div>
            </div> 
            <div className="bg-busines-type h-auto lg:pt-[8.44rem] py-3">
              <div className="lg:px-[5.69rem] px-3 ">
                <BusinessType setActive={setActive} />
              </div>
            </div>
             <div className="lg:px-[5.69rem] px-3  lg:py-[6.5rem] py-[3rem]">
              <Payments setActive={setActive} />
            </div>
            <div className="lg:px-[5.69rem] px-3 mt-[4.97rem] bg-white">
              <Partners />
            </div>
            <div className="lg:px-[5.69rem] px-3 lg:mt-[5.03rem] mt-[2rem] py-[2.75rem] bg-[#1E191B] shadow-[0_0_0_1px_rgba(0,0,0,0.05)]">
              <Security />
            </div>
            <div className="lg:px-[5.69rem] px-3 mt-[4.12rem] bg-white">
              <Testimonial />
            </div>
            <div className="bg-busines-type h-auto lg:pt-[8.44rem] py-3" id="faq">
              <div className="lg:px-[5.69rem] px-3 ">
                <Faq />
              </div>
            </div>
          </>
        )}
        <div className="">
          <Footer active={active} setActive={setActive} />
        </div>
      </div>
    </>
  );
}

export default Landing;
